export function onScroll() {
	const navbar = $(".navbar");

	if (window.scrollY > 0) {
		navbar.addClass("navbar-scrolled");
	} else {
		navbar.removeClass("navbar-scrolled");
	}
}
